var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 8.688,
    viewBox: "0 0 16 8.688",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron-down",
    d: "M16.749,152.356l-.255-.255a.431.431,0,0,0-.61,0l-7.008,7.011L1.866,152.1a.431.431,0,0,0-.61,0L1,152.356a.431.431,0,0,0,0,.61l7.567,7.571a.431.431,0,0,0,.61,0l7.567-7.571A.428.428,0,0,0,16.749,152.356Z",
    transform: "translate(-0.875 -151.975)",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-down.178d8097aa5a5fff49ebd53e6d1b86d5.svg";